import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { LocationList } from '../../components/LocationList';
import i18n from '../../utils/i18n';
import { locationSelector } from '../../selectors/cuisineSelectors';

export class CuisineLocationListContainer extends React.Component {
  render() {
    const { locations, isCityPage } = this.props;

    if (!locations.length) return null;

    const containerId = isCityPage ? 'choose-neighbourhood' : 'choose-city';
    const headerText = i18n.gettext(
      `landingPage.cuisine.chooseLocation.${isCityPage ? 'neighbourhood' : 'city'}`,
    );

    return <LocationList locations={locations} containerId={containerId} headerText={headerText} />;
  }
}

CuisineLocationListContainer.propTypes = {
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
  isCityPage: PropTypes.bool.isRequired,
};

CuisineLocationListContainer.defaultProps = {
  locations: [],
};
export default connect(locationSelector)(CuisineLocationListContainer);
